import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f2d838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description-text" }
const _hoisted_2 = { class: "description-text" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Guardar")

import { nextTick, onMounted, ref, watch } from "vue";
import { ReportFilter } from "@/types/report.type";
import { Parameter } from "@/types/parameter.type";
import GraphDonutChartComponent from "../graphs/graphDonutChart.component.vue";
import ElMessage from "element-plus/lib/components/message";
import { useI18n } from "vue-i18n";
import {
  calculateParameterRange,
  calculateTmoaRange,
  postParameterRange,
  getParameterRange,
  calculateHourlyData,
  calculateWeeklyData,
  calculateHourlyDataParam,
  calculateWeeklyDataParam,
} from "@/service/parameterRange.service";
import { TableParameterRange, TableRange, ParameterRange } from "@/types/parameterRange.type";
import { ValidationFilter_2 } from "@/types/estimation.type";
import { Filter } from "@/types/filter.type";
import { getTmoa, updateTmoaUser } from "@/service/tmoa.service";
import { sortByType } from "@/utils/tmoa.util";
import type { RowClassNameGetter } from "element-plus";
import { Tmoa } from "@/types/tmoa.type";
import { Color } from "@amcharts/amcharts5/.internal/core/util/Color";
import { Refresh } from "@element-plus/icons-vue";
import * as am5 from "@amcharts/amcharts5";
import { formatNumber, parseNumber } from "@/utils/estimation.util";
import jsPDF from "jspdf";
import { exportToPdf } from "@/utils/pdf.util";
import { getParameterRanges } from "@/service/estimation.service";


export default /*#__PURE__*/_defineComponent({
  props: {
    reportFilter: null,
    parameter: null,
    point: null,
    date: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  reportFilter: ReportFilter;
  parameter: Parameter | undefined;
  point: string | undefined;
  date: string | undefined;
}


const tableParameterRange = ref<TableParameterRange[]>([]);
const tableTemporal = ref<TableRange[]>([]);
const tableTmoa = ref<any[]>();
let graphProbability = ref<
  Array<{
    name: string;
    value: number;
    tmoa?: string;
    strokeSettings?: { fill: Color; stroke: Color };
  }>
>([]);
const graphLoaded = ref<boolean>(false); // Control para cargar el componente
const openEditModal = ref<boolean>(false);
const disabledBtnSave = ref<boolean>(false);
let editedTmoa = ref<Tmoa>();

const isExporting = ref<boolean>(false);

const isWideScreen = ref<boolean>(window.innerWidth > 1490);

const tableHourlyStats = ref<
  Array<{
    tmoa: number;
    "00:00-08:00": number;
    "08:00-16:00": number;
    "16:00-00:00": number;
  }>
>([]);

const tableHourlyStatsParam = ref<
  Array<{
    id: number;
    nameRange: string;
    "00:00-08:00": number;
    "08:00-16:00": number;
    "16:00-00:00": number;
  }>
>([]);

const tableWeeklyStats = ref<
  Array<{
    tmoa: number;
    lunes: number;
    martes: number;
    miércoles: number;
    jueves: number;
    viernes: number;
    sábado: number;
    domingo: number;
  }>
>([]);

const { t } = useI18n();

const tableNewParameterRanges = ref<any[]>([]);

onMounted(async () => {
  openEditModal.value = false;
  disabledBtnSave.value = false;

  await getInformation();
  await nextTick();
  window.addEventListener("resize", updateScreenSize);

  let resp = await getParameterRanges(props.reportFilter.samplingPointIds[0], props.parameter.id);

  if (resp && Array.isArray(resp)) {
    tableNewParameterRanges.value = resp;
  }
});

const spanMethod = ({ column, rowIndex }) => {
  if (!column) return;
  if (column.property === "code") {
    if (tableNewParameterRanges.value.length === 0) return { rowspan: 1, colspan: 1 };
    if (rowIndex === 0) {
      return { rowspan: tableNewParameterRanges.value.length, colspan: 1 };
    } else {
      return { rowspan: 0, colspan: 0 };
    }
  }
  return;
};

const addWatermark = (pdf: jsPDF, imgData: string) => {
  const pageCount = pdf.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);

    // Puedes ajustar tamaño y posición aquí
    const width = 150;
    const height = 45;
    const x = (pdf.internal.pageSize.getWidth() - width) / 2;
    const y = (pdf.internal.pageSize.getHeight() - height) / 2;

    pdf.addImage(imgData, "PNG", x, y, width, height, "", "NONE", 0.1); // 0.1 = opacidad
  }
};

const getBase64Image = (url: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (ctx?.globalAlpha) {
        ctx.globalAlpha = 0.05;
      }
      ctx?.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (err) => reject(err);
  });
};

const btnExportToPdf = async () => {
  // Ocultar columnas antes de empezar
  isExporting.value = true;

  setTimeout(async () => {
    const title = `Informe de ${props.parameter?.name} en ${props.point}`;
    const subtitle = `${props.date}`;

    const dateTime1 = props.date?.split(" - ")[0];
    const date1 = dateTime1 ? dateTime1.split("/") : "";
    const time1 = date1[2].split(":");
    const dateString1 = `${date1[2].split(" ")[0]}${date1[1]}${date1[0]}${time1[0].split(" ")[1]}${
      time1[1]
    }`;
    const dateTime2 = props.date?.split(" - ")[1];
    const date2 = dateTime2 ? dateTime2.split("/") : "";
    const time2 = date2[2].split(":");
    const dateString2 = `${date2[2].split(" ")[0]}${date2[1]}${date2[0]}${time2[0].split(" ")[1]}${
      time1[1]
    }`;

    const namePDF = `${props.point?.replace(/ /g, "_")}_${
      props.parameter?.code
    }_${dateString1}_${dateString2}`;
    // Mostrar de nuevo las columnas ocultas después de capturar
    await exportToPdf(title, subtitle, namePDF, ["a", "b", "c"]);
    isExporting.value = false;
  }, 200);
};

const formatPercentage = (row: any, column: any, cellValue: number) => {
  if (cellValue == 0) return "-";
  if (cellValue === 1) return "1";
  return `${cellValue} %`;
};

const formatNA = (row: any, column: any, cellValue: string | number) => {
  if (cellValue === "N/A") return "-";
  if (cellValue === 1) return "1";
  return `${cellValue}`;
};

const getTmoaNameByValue = (row: any, column: any, cellValue: any): string => {
  const value = Number(cellValue);
  const found = tableTmoa.value?.find((item) => item.value === value);

  if (!found) return "";

  return found.name?.trim() ? found.name : found.type || "";
};

const getTmoaName = (value: any): string => {
  const found = tableTmoa.value?.find((item) => item.value === value);
  return found ? found.name : value;
};

const formatHourlyTable = (
  rawData: {
    id: number;
    nameRange: string;
    "00:00-08:00": number;
    "08:00-16:00": number;
    "16:00-00:00": number;
  }[]
): any[] => {
  const hourKeys = ["00:00-08:00", "08:00-16:00", "16:00-00:00"];

  const allRangesMap = new Map<string, { id: number; nameRange: string }>();

  for (const hour of hourKeys) {
    for (const entry of rawData[hour] || []) {
      if (!allRangesMap.has(entry.nameRange)) {
        allRangesMap.set(entry.nameRange, { id: entry.id, nameRange: entry.nameRange });
      }
    }
  }

  const sortedRanges = Array.from(allRangesMap.values()).sort((a, b) => {
    const numA = parseInt(a.nameRange.replace(/\D/g, "")) || 0;
    const numB = parseInt(b.nameRange.replace(/\D/g, "")) || 0;
    return numA - numB;
  });

  const result = sortedRanges.map((range) => {
    const row: Record<string, any> = {
      id: range.id,
      nameRange: range.nameRange,
    };

    for (const hour of hourKeys) {
      const match = rawData[hour]?.find((r) => r.nameRange === range.nameRange);
      row[hour] = match ? match.percentage.toFixed(2) : "0.00";
    }

    return row;
  });

  return result;
};
const formatWeeklyTable = (rawData: Record<string, any[]>) => {
  const dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
  const result: any[] = [];

  // Determinar cuántos rangos hay usando el primer día con datos
  const sampleDay = dias.find((d) => rawData[d]?.length > 0);
  const numRangos = sampleDay ? rawData[sampleDay].length : 0;

  for (let i = 0; i < numRangos; i++) {
    const row: Record<string, any> = {
      tmoa: rawData[sampleDay][i]?.nameRange,
    };

    for (const dia of dias) {
      row[dia] = Number(rawData[dia]?.[i]?.percentage.toFixed(2)) ?? 0;
    }

    result.push(row);
  }

  return result;
};

const getInformation = async () => {
  graphLoaded.value = false;
  tableTemporal.value = [] as TableRange[];
  tableParameterRange.value = [] as ParameterRange[];
  tableNewParameterRanges.value = [];
  if (props.parameter) {
    tableNewParameterRanges.value = await getParameterRanges(
      props.reportFilter.samplingPointIds[0],
      props.parameter.id
    );
    const validationFilter = {
      samplingPointId: [props.reportFilter.samplingPointIds[0]],
      parameterId: [props.parameter.id],
      date: [props.reportFilter.date[0], props.reportFilter.date[1]],
    } as ValidationFilter_2;

    if (props.parameter.code !== "TMOA") {
      await getInformationRange(props.parameter, validationFilter);

      const rawHourlyData = await calculateHourlyDataParam(validationFilter);
      tableHourlyStatsParam.value = formatHourlyTable(rawHourlyData);

      let rawWeeklyData = await calculateWeeklyDataParam(validationFilter);
      tableWeeklyStats.value = formatWeeklyTable(rawWeeklyData);
    } else {
      tableTmoa.value = sortByType([...(await getTmoaBySamplingPoint())]);

      const information = await calculateTmoaRange(validationFilter);
      tableHourlyStats.value = await calculateHourlyData(validationFilter);
      tableWeeklyStats.value = await calculateWeeklyData(validationFilter);

      showInformation(information);
    }
  }
};

const getInformationRange = async (parameter: Parameter, validationFilter: ValidationFilter_2) => {
  const parameterRanges = await getParameterRange(
    props.reportFilter.samplingPointIds[0],
    parameter.id
  );
  if (parameterRanges.length > 0) {
    tableParameterRange.value = [];
    //- Parámetros
    [1, 2, 3, 4].forEach((range) => {
      const existRange = parameterRanges.find((_) => _?.nameRange === `Rango ${range}`);
      if (existRange) {
        console.log("AAA - tableParameterRange if");
        tableParameterRange.value.push({
          id: existRange.id,
          nameRange: `${t("label.range")} ${range}`,
          beginningRange: formatNumber(existRange.beginningRange),
          endRange: formatNumber(existRange.endRange),
          samplingPoint: existRange.samplingPoint,
          parameter: existRange.parameter,
        });
      } else {
        console.log("AAA - tableParameterRange else");
        tableParameterRange.value.push({
          nameRange: `${t("label.range")} ${range}`,
          beginningRange: undefined,
          endRange: undefined,
        });
      }
    });
    console.log("AAA - tableParameterRange", tableParameterRange.value);
    tableTemporal.value = [] as TableRange[];
    const information = await calculateParameterRange(validationFilter);
    if (information) {
      showInformation(information);
    }
  } else {
    //- Si no se han establecido parámetros

    await initialParameterRange();
    graphProbability.value = [] as Array<{ name: string; value: number; tmoa: string }>;
    tableTemporal.value = [] as TableRange[];
  }
};

const showInformation = (information: { tableRange: TableRange[]; graphProbability: number[] }) => {
  tableTemporal.value = [];
  graphProbability.value = [];

  const isTmoa = props.parameter?.code === "TMOA";

  information.tableRange?.forEach((element) => {
    element.nameRange = `${element.nameRange}`;
    element.min_duration = element.min_duration || "N/A";
    element.max_duration = element.max_duration || "N/A";
    element.average_duration = element.average_duration || "N/A";
    element.total = element.total || "N/A";
    tableTemporal.value?.push(element);
  });

  information.graphProbability?.forEach((value, index) => {
    if (value !== undefined && value > 0) {
      let name = "";
      let tmoaLabel = "";

      if (isTmoa) {
        const tmoa = tableTmoa.value?.find((t) => t.value === index + 1);
        name = tmoa?.name?.trim() || `TMOA ${index + 1}`;
        tmoaLabel = name;
      } else {
        name = `Rango ${index + 1}`;
      }

      const entry: any = {
        name,
        value,
      };

      if (isTmoa) {
        entry.tmoa = tmoaLabel;

        if (index + 1 === tableTmoa.value?.length) {
          entry.strokeSettings = {
            fill: am5.color(0xf37878),
            stroke: am5.color(0xf37878),
          };
        }
      }

      graphProbability.value.push(entry);
    }
  });

  // Mostrar gráfico si hay datos
  if (graphProbability.value.length > 0) {
    graphLoaded.value = true;
  }
};

const initialParameterRange = async () => {
  tableParameterRange.value = [] as TableParameterRange[];
  for (let index = 0; index < 4; index++) {
    tableParameterRange.value.push({
      id: undefined,
      nameRange: `${t("label.range")} ${index + 1}`,
      beginningRange: undefined,
      endRange: undefined,
      status: false,
    });
  }
};

const showEdit = (index: number, element: any) => {
  element.beginningRange = validateInput(element.beginningRange);
  element.endRange = validateInput(element.endRange);

  const endRangePrevious =
    index > 0 && tableParameterRange.value
      ? parseNumber(tableParameterRange.value[index - 1].endRange)
      : undefined;
  const beginningRangeNext =
    index > 0 && tableParameterRange.value && tableParameterRange.value.length > index + 1
      ? parseNumber(tableParameterRange.value[index + 1].beginningRange)
      : undefined;

  const end = parseNumber(element.endRange);
  const beginning = parseNumber(element.beginningRange);
  if (element.status) {
    // Comprobar en la misma fila
    if (end !== null && beginning !== null) {
      if (end < beginning || end === beginning) {
        ElMessage.warning(t("warning.confNotAllowed"));
      } else if (index > 0 && endRangePrevious !== null && beginning < endRangePrevious) {
        // Comprobar con respecto a la fila anterior
        ElMessage.warning(t("warning.confNotAllowed"));
      } else if (index > 0 && beginningRangeNext !== null && end > beginningRangeNext) {
        // Comprobar con respecto a la siguiente fila
        ElMessage.warning(t("warning.confNotAllowed"));
      } else {
        element.status = false;
        disabledBtnSave.value = false;
      }
    } else {
      if ((end !== null && beginning) || (end && beginning !== null)) {
        ElMessage.warning(t("warning.confNotAllowed"));
      } else {
        element.status = false;
        disabledBtnSave.value = false;
      }
    }
  } else {
    element.status = true;
    element.samplingPoint = props.reportFilter.samplingPointIds[0];
    element.parameter = props.parameter?.id;
    if (beginning === undefined) {
      element.beginningRange = end;
    }

    disabledBtnSave.value = true;
  }
};

const saveRanges = async () => {
  try {
    console.log("[saveRanges] Iniciando guardado de rangos...");
    const rangesWithValues = tableParameterRange.value
      .filter((range) => range.beginningRange !== undefined && range.endRange !== undefined)
      .map((range) => {
        return {
          beginningRange: parseNumber(range.beginningRange),
          endRange: parseNumber(range.endRange),
          samplingPoint: props.reportFilter.samplingPointIds[0],
          parameter: props.parameter?.id,
          nameRange: range.nameRange,
          id: range.id,
        } as unknown as ParameterRange;
      });

    if (rangesWithValues.length > 0 && props.parameter?.id) {
      const item = await postParameterRange(rangesWithValues);

      item.forEach((element, idx) => {
        let index = -1;
        if (tableParameterRange.value && element) {
          index = tableParameterRange.value.findIndex((i) => i.nameRange === element.nameRange);
          if (index !== -1 && element) {
            element.endRange = formatNumber(element.endRange);
            element.beginningRange = formatNumber(element.beginningRange);
            tableParameterRange.value[index] = element;
          } else {
            console.warn(`[saveRanges] No se encontró coincidencia para:`, element);
          }
        }
      });

      const validationFilter = {
        samplingPointId: [props.reportFilter.samplingPointIds[0]],
        parameterId: [props.parameter.id],
        date: [props.reportFilter.date[0], props.reportFilter.date[1]],
      } as ValidationFilter_2;

      const information = await calculateParameterRange(validationFilter);

      const rawHourlyData = await calculateHourlyDataParam(validationFilter);
      tableHourlyStatsParam.value = formatHourlyTable(rawHourlyData);

      let rawWeeklyData = await calculateWeeklyDataParam(validationFilter);
      tableWeeklyStats.value = formatWeeklyTable(rawWeeklyData);

      if (information) {
        showInformation(information);
      }
    } else {
      console.warn("[saveRanges] No se enviaron rangos: condición no cumplida.");
    }
  } catch (error) {
    console.error("[saveRanges] Error: ", error);
  }
};

const checkValueRange = (index: number) => {
  let disabledEdit = true;

  // Permitir editar siempre al primer elemento y si el anterior elemento tiene datos
  if (
    index === 0 ||
    (tableParameterRange.value &&
      tableParameterRange.value[index - 1].beginningRange &&
      tableParameterRange.value[index - 1].endRange)
  ) {
    disabledEdit = false;
  }
  // Borrar rangos si se ha eliminado el rango anterior
  if (
    tableParameterRange.value &&
    tableParameterRange.value[index].beginningRange &&
    tableParameterRange.value[index].endRange &&
    disabledEdit &&
    !tableParameterRange.value[index - 1].status
  ) {
    tableParameterRange.value[index].beginningRange = undefined;
    tableParameterRange.value[index].endRange = undefined;
  }

  return disabledEdit;
};

const getTmoaBySamplingPoint = () => {
  const samplingPointId = props.reportFilter.samplingPointIds[0];
  const filter: Filter = {
    fields: {
      "tmoa.samplingPointId": { operator: "equal", value: samplingPointId },
    },
  };
  return getTmoa(filter);
};

/**
 * Poner en rojo la fila de las anomalías
 * @param param0
 */
const tableRowClassName = ({ rowIndex }: Parameters<RowClassNameGetter<any>>[0]) => {
  if (tableTmoa.value && tableTmoa.value[rowIndex].value === tableTmoa.value?.length) {
    return "red no-hover";
  }
  return "no-hover";
};

const editTmoa = (row: Tmoa) => {
  editedTmoa.value = { ...row };
  openEditModal.value = true;
};

const closeModal = () => {
  editedTmoa.value = {} as Tmoa;
  openEditModal.value = false;
};

const saveTmoa = async () => {
  await updateTmoaUser(editedTmoa.value?.id, editedTmoa.value?.name, editedTmoa.value?.description);
  const index = tableTmoa.value?.findIndex((item) => item.id === editedTmoa.value?.id);
  if (index !== undefined && tableTmoa.value) {
    tableTmoa.value[index] = editedTmoa.value;
  }

  openEditModal.value = false;
};

const validateInput = (value: string) => {
  if (!isNaN(Number(value))) {
    value = formatNumber(value);
  }
  return value;
};
const updateScreenSize = () => {
  isWideScreen.value = window.innerWidth > 1445;
};

// - VUE EXPOSE
expose({
  btnExportToPdf,
});

watch(
  () => props.parameter,
  async () => {
    await getInformation();
  }
);
watch(
  () => [...props.reportFilter.date],
  async () => {
    await getInformation();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_center = _resolveComponent("center")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_scrollbar, { height: "70vh" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, {
          id: "a",
          class: "statistical-components scrollbar-demo-item responsive-row"
        }, {
          default: _withCtx(() => [
            (__props.parameter?.code == 'TMOA')
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 24,
                  class: "responsive-col",
                  id: "uno"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { class: "row-table static" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, {
                          id: "header-tmoa",
                          class: "header"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.parameterRanges")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableTmoa.value,
                          "row-class-name": tableRowClassName,
                          style: {"width":"100%"},
                          border: "",
                          class: "table-report"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "name",
                              label: _ctx.$t('parameterType.tmoa')
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(scope.row.name || "TMOA " + scope.row.value), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "value",
                              label: "Nº TMOA"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "description",
                              label: _ctx.$t('label.description')
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(scope.row.description), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            (!isExporting.value)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  label: "Editar"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_center, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          size: "small",
                                          onClick: ($event: any) => (editTmoa(scope.row))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("em", {
                                              class: "el-icon el-icon-edit fas",
                                              style: {"cursor":"pointer"},
                                              title: _ctx.$t('btn.edit')
                                            }, null, 8, _hoisted_3)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, {
              span: 12,
              id: "dos",
              class: "responsive-col"
            }, {
              default: _withCtx(() => [
                (__props.parameter?.code !== 'TMOA')
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 0,
                      class: "row-table"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, {
                          id: "header-range",
                          class: "header"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.parameterRanges")) + " ", 1),
                            (!isExporting.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: saveRanges,
                                  disabled: disabledBtnSave.value,
                                  icon: _unref(Refresh),
                                  circle: ""
                                }, null, 8, ["disabled", "icon"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableParameterRange.value,
                          border: "",
                          ref: "trange",
                          class: "table-report",
                          style: {"width":"100%"},
                          fit: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "nameRange",
                              label: _ctx.$t('label.range')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "beginningRange",
                              label: _ctx.$t('label.beginningRange')
                            }, {
                              default: _withCtx((scope) => [
                                (scope.row.status)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_el_input, {
                                        modelValue: scope.row.beginningRange,
                                        "onUpdate:modelValue": ($event: any) => ((scope.row.beginningRange) = $event),
                                        size: "small"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "endRange",
                              label: _ctx.$t('label.endRange')
                            }, {
                              default: _withCtx((scope) => [
                                (scope.row.status)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createVNode(_component_el_input, {
                                        modelValue: scope.row.endRange,
                                        "onUpdate:modelValue": ($event: any) => ((scope.row.endRange) = $event),
                                        size: "small"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            (!isExporting.value)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  prop: "edit",
                                  label: _ctx.$t('btn.edit'),
                                  align: "center"
                                }, {
                                  default: _withCtx((scope) => [
                                    (!scope.row.status)
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          size: "small",
                                          onClick: ($event: any) => (showEdit(scope.$index, scope.row)),
                                          disabled: checkValueRange(scope.$index)
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("em", {
                                              class: "el-icon el-icon-edit fas",
                                              title: _ctx.$t('btn.edit')
                                            }, null, 8, _hoisted_6)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "disabled"]))
                                      : (_openBlock(), _createBlock(_component_el_button, {
                                          key: 1,
                                          type: "success",
                                          size: "small",
                                          onClick: ($event: any) => (showEdit(scope.$index, scope.row))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("em", {
                                              class: "el-icon el-icon-check fas",
                                              title: _ctx.$t('btn.activate')
                                            }, null, 8, _hoisted_7)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_row, { class: "row-table static" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, {
                      id: "header-metrics",
                      class: "header"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("label.globalAnalysis")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      data: tableTemporal.value,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        (__props.parameter?.code == 'TMOA')
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              prop: "nameRange",
                              label: "TMOA",
                              width: "120",
                              formatter: getTmoaNameByValue
                            }))
                          : (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              prop: "nameRange",
                              label: _ctx.$t('label.range'),
                              width: "120",
                              formatter: (row) => `Rango ${row.nameRange}`
                            }, null, 8, ["label", "formatter"])),
                        _createVNode(_component_el_table_column, {
                          prop: "min_duration",
                          label: _ctx.$t('label.min'),
                          formatter: formatNA
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "max_duration",
                          label: _ctx.$t('label.max'),
                          formatter: formatNA
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "average_duration",
                          label: _ctx.$t('label.average'),
                          formatter: formatNA
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "total",
                          label: _ctx.$t('label.total'),
                          formatter: formatNA
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }),
                (props.parameter && props.parameter.code == 'TMOA')
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 1,
                      class: "row-table static"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.numTmoaPercentage")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableHourlyStats.value,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "tmoa",
                              label: _ctx.$t('parameterType.tmoa'),
                              formatter: getTmoaNameByValue
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "00:00-08:00",
                              label: "00:00 - 08:00",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "08:00-16:00",
                              label: "08:00 - 16:00",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "16:00-00:00",
                              label: "16:00 - 23:59",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_row, {
                      key: 2,
                      class: "row-table static"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.numTmoaPercentage")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableHourlyStatsParam.value,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "nameRange",
                              label: _ctx.$t('label.range')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "00:00-08:00",
                              label: "00:00 - 08:00",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "08:00-16:00",
                              label: "08:00 - 16:00",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "16:00-00:00",
                              label: "16:00 - 23:59",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    })),
                (props.parameter?.code === 'TMOA' && !isWideScreen.value)
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 3,
                      class: "row-table static"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.weekDays")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableWeeklyStats.value,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "tmoa",
                              label: _ctx.$t('parameterType.tmoa'),
                              formatter: getTmoaNameByValue
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "lunes",
                              label: "Lunes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "martes",
                              label: "Martes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "miércoles",
                              label: "Miércoles",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "jueves",
                              label: "Jueves",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "viernes",
                              label: "Viernes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "sábado",
                              label: "Sábado",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "domingo",
                              label: "Domingo",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (props.parameter?.code !== 'TMOA' && !isWideScreen.value)
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 4,
                      class: "row-table static"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.weekDays")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableWeeklyStats.value,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "tmoa",
                              label: _ctx.$t('label.range')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "Lunes",
                              label: "Lunes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Martes",
                              label: "Martes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Miércoles",
                              label: "Miércoles",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Jueves",
                              label: "Jueves",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Viernes",
                              label: "Viernes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Sábado",
                              label: "Sábado",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Domingo",
                              label: "Domingo",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 12,
              id: "tres",
              class: "responsive-col"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_el_row, {
                  id: "header-temporal",
                  class: "header static"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("label.graphAnalysisReport")), 1)
                  ]),
                  _: 1
                }),
                (graphLoaded.value && _unref(graphProbability).length)
                  ? (_openBlock(), _createBlock(GraphDonutChartComponent, {
                      key: props.parameter?.code,
                      probability: _unref(graphProbability),
                      idChart: 'chartdiv'
                    }, null, 8, ["probability"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { id: "b" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              class: "row-table static",
              style: {"width":"100%","margin-top":"20px"},
              fit: true
            }, {
              default: _withCtx(() => [
                (props.parameter?.code === 'TMOA' && isWideScreen.value)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.weekDays")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableWeeklyStats.value,
                          border: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "tmoa",
                              label: _ctx.$t('parameterType.tmoa'),
                              formatter: getTmoaNameByValue
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "lunes",
                              label: "Lunes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "martes",
                              label: "Martes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "miércoles",
                              label: "Miércoles",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "jueves",
                              label: "Jueves",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "viernes",
                              label: "Viernes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "sábado",
                              label: "Sábado",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "domingo",
                              label: "Domingo",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (props.parameter?.code !== 'TMOA' && isWideScreen.value)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "header" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.weekDays")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table, {
                          data: tableWeeklyStats.value,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "tmoa",
                              label: _ctx.$t('label.range')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "Lunes",
                              label: "Lunes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Martes",
                              label: "Martes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Miércoles",
                              label: "Miércoles",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Jueves",
                              label: "Jueves",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Viernes",
                              label: "Viernes",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Sábado",
                              label: "Sábado",
                              formatter: formatPercentage
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Domingo",
                              label: "Domingo",
                              formatter: formatPercentage
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(editedTmoa))
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: openEditModal.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((openEditModal).value = $event)),
          title: "Editar matriz de agua",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_el_button, { onClick: closeModal }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveTmoa
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "editForm",
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "TMOA" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(editedTmoa).name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editedTmoa).name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Descripción" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editedTmoa).description) = $event)),
                      class: "el-textarea",
                      maxlength: "250"
                    }, null, 512), [
                      [_vModelText, _unref(editedTmoa).description]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})